import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, inject, input } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { ButtonLinkConfig } from '@/app/models/button-link.model';
import { RightClickDirective } from '@/app/directives/right-click.directive';
import { MixPanelEvent, MixPanelService } from '@/app/services/mixpanel.service';

@Component({
  selector: 'dr-flex-home-ui-link-button',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [RouterModule, RightClickDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './link-button.component.html',
  styleUrl: './link-button.component.scss',
})
export class LinkButtonComponent {
  link = input.required<ButtonLinkConfig>();
  size = input<'sm' | 'md' | 'lg'>('md');
  mixpanelClickEvent = input<MixPanelEvent | null>(null);
  readonly router = inject(Router);
  private readonly mixpanelService = inject(MixPanelService);

  openLink() {
    const link = this.link();
    this.trackMixpanelClickEvent();
    if (link.internal) {
      this.router.navigateByUrl(link.href);
      return;
    }
    if (link.allowRightClick) {
      window.location.href = link.href;
      return;
    }
    window.open(link.href, link.target ?? '_blank');
  }

  private trackMixpanelClickEvent(): void {
    const event = this.mixpanelClickEvent();

    if (!event) {
      return;
    }

    this.mixpanelService.trackEvent(event);
  }

  rightClick() {
    const link = this.link();
    if (!link.allowRightClick) return;

    window.open(link.href, link.target ?? '_blank');
  }
}
